"use strict";

/**
 *
 * Initializes and manages the image cropping.
 *
 * @param {function} onCropCompelete A callback that fires after the croping is
 *                                   completed.
 *js-image-cropper-input
 */

require("cropperjs/dist/cropper.css");
const Cropper = require("cropperjs");
const bookingImageUploader = require("./../booking-image-uploader/booking-image-uploader");

var cropper = null;

function initCropper(imageUploader, onCropComplete) {
  const cropperElement = $(".js-image-cropper-target").get(0);

  if (cropper) {
    cropper.destroy();
  }

  const imageAspectratio = $(imageUploader).attr("data-aspect-ratio");
  let ar = 16 / 9;
  if (imageAspectratio === "portrait") {
    ar = 3 / 4;
  } else if (imageAspectratio === "square") {
    ar = 1;
  } else if (imageAspectratio == "other") {
    $(".js-change-aspect-ratio").attr("hidden", false);
  }

  cropper = new Cropper(cropperElement, {
    aspectRatio: ar,
    viewMode: 2,
    background: true
  });

  $(".js-image-cropper").off("hide.bs.modal");
  $(".js-image-crooper-submit").off("click");
  $(".js-change-aspect-ratio").off("click");

  $(".js-image-cropper").on("hide.bs.modal", function() {
    cropper.destroy();
    $(".js-image-cropper-description").val("");
    $(".js-image-cropper").removeClass("image-cropper--has-image");
    $(imageUploader).attr("cropped", false);
    $(".js-change-aspect-ratio").attr("hidden", true);
  });

  $(".js-image-crooper-submit").on("click", function(e) {
    const aspectRatio = $(".js-change-aspect-ratio").attr("data-aspect-ratio");

    let config = {
      width: 1280,
      height: 720,
      minWidth: 1280,
      minHeight: 720,
      maxWidth: 1280,
      maxHeight: 720
    };

    if (aspectRatio == "landscape") {
      config = {
        width: 1280,
        height: 720,
        minWidth: 1280,
        minHeight: 720,
        maxWidth: 1280,
        maxHeight: 720
      };
    } else if (aspectRatio == "portrait") {
      config = {
        width: 960,
        height: 1280,
        minWidth: 960,
        minHeight: 1280,
        maxWidth: 960,
        maxHeight: 1280
      };
    } else if (aspectRatio == "square") {
      config = {
        width: 1280,
        height: 1280,
        minWidth: 1280,
        minHeight: 1280,
        maxWidth: 1280,
        maxHeight: 1280
      };
    }

    const croppedCanvas = cropper.getCroppedCanvas(config);
    const description = $(".js-image-cropper-description").val();

    $(imageUploader)
      .find(".js-canvas-wrapper")
      .append(croppedCanvas);

    $(imageUploader)
      .find("input[name=description]")
      .val(description);

    $(imageUploader).attr("cropped", true);

    const croppedImage = croppedCanvas.toDataURL("image/png");
    bookingImageUploader.setImageuploaderToEditMode(imageUploader);

    const imageElement = $(imageUploader)
      .find(".js-image-uploader-target")
      .get(0);
    const type = $(imageUploader).attr("data-type");
    const wrapper = imageUploader;

    bookingImageUploader.validateImageConstraints(
      croppedImage,
      imageElement,
      type,
      wrapper
    );

    $(".js-image-cropper").modal("hide");
    onCropComplete && onCropComplete();
  });

  if (imageAspectratio === "other") {
    $(".js-change-aspect-ratio").on("click", function() {
      const currentAspectRatio = $(".js-change-aspect-ratio").attr(
        "data-aspect-ratio"
      );
      const toPrortrait = $(".js-change-aspect-ratio").attr("data-to-portrait");
      const toLandscape = $(".js-change-aspect-ratio").attr(
        "data-to-landscape"
      );

      if (currentAspectRatio == "landscape") {
        $(".js-change-aspect-ratio").attr("data-aspect-ratio", "portrait");
        $(".js-change-aspect-ratio").text(toPrortrait);
        cropper.setAspectRatio(3 / 4);
        cropper.setCropBoxData({
          width: 960,
          height: 1280,
          minWidth: 960,
          minHeight: 1280,
          maxWidth: 960,
          maxHeight: 1280
        });
      } else if (currentAspectRatio == "portrait") {
        $(".js-change-aspect-ratio").attr("data-aspect-ratio", "landscape");
        $(".js-change-aspect-ratio").text(toLandscape);
        cropper.setAspectRatio(16 / 9);
        cropper.setCropBoxData({
          width: 1280,
          height: 720,
          minWidth: 1280,
          minHeight: 720,
          maxWidth: 1280,
          maxHeight: 720
        });
      }
    });
  }
}

function setupLoader(imageUploader, onCropComplete) {
  $(".js-image-cropper-input").off("change");
  $(".js-image-cropper-input").on("change", function(changeEvent) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(changeEvent.target.files[0]);

    fileReader.onload = function(fileReaderLoadEvent) {
      const image = fileReaderLoadEvent.target.result;
      const img = new Image();
      img.src = image;

      img.onload = function() {
        $(".js-image-cropper-target").attr("src", image);
        initCropper(imageUploader, onCropComplete);
        $(".js-image-cropper").addClass("image-cropper--has-image");
      };
    };
  });
}

/**
 *
 * Initializes the image cropper module.
 *
 */
function onLoad(onCropComplete, consentControl) {
  $(".js-image-uploader").each(function(i, imageUploader) {
    const editButton = $(imageUploader).find(".js-image-edit");
    const editButtonPreviewImage = $(imageUploader).find(
      ".image-uploader__loader-wrapper"
    );
    const editButtonWithImage = $(imageUploader).find(
      ".js-image-edit-with-image"
    );

    /**
     *
     * Button when there is no image
     *
     */
    $(editButton).on("click", function() {
      consentControl(function(e) {
        var imageType = $(imageUploader).attr("data-type");
        var imageIndex = $(imageUploader).attr("data-index");
        var allImages = $(".js-image-uploader").length;
        var cropperTitle = $(".js-image-cropper-title").attr(
          "data-other-title"
        );

        // decide what help box to show.
        if (imageType === "avatar") {
          $(".js-image-cropper").addClass("image-cropper--avatar");
          $(".js-image-cropper").removeClass("image-cropper--image1");
          cropperTitle = $(".js-image-cropper-title").attr("data-avatar-title");
        } else if (imageType === "image1") {
          $(".js-image-cropper").removeClass("image-cropper--avatar");
          $(".js-image-cropper").addClass("image-cropper--image1");
          cropperTitle = $(".js-image-cropper-title").attr("data-image1-title");
        } else {
          $(".js-image-cropper").removeClass("image-cropper--avatar");
          $(".js-image-cropper").removeClass("image-cropper--image1");
        }

        // initialize the variables
        $(".js-image-cropper-title").text(cropperTitle);
        $(".js-image-cropper-counter").text(imageIndex);
        $(".js-image-cropper-counter-total").text(allImages);

        $(".js-image-cropper").off("shown.bs.modal");
        $(".js-image-cropper").on("shown.bs.modal", function() {
          $("#image-crop-consent").prop("checked", false);
          setupLoader(imageUploader, onCropComplete);
        });

        $(".js-image-cropper").modal({ backdrop: "static" });
      });
    });
    //make camera icon clickable
    $(editButtonPreviewImage).on("click", function() {
      consentControl(function(e) {
        var imageType = $(imageUploader).attr("data-type");
        var imageIndex = $(imageUploader).attr("data-index");
        var allImages = $(".js-image-uploader").length;
        var cropperTitle = $(".js-image-cropper-title").attr(
          "data-other-title"
        );

        // decide what help box to show.
        if (imageType === "avatar") {
          $(".js-image-cropper").addClass("image-cropper--avatar");
          $(".js-image-cropper").removeClass("image-cropper--image1");
          cropperTitle = $(".js-image-cropper-title").attr("data-avatar-title");
        } else if (imageType === "image1") {
          $(".js-image-cropper").removeClass("image-cropper--avatar");
          $(".js-image-cropper").addClass("image-cropper--image1");
          cropperTitle = $(".js-image-cropper-title").attr("data-image1-title");
        } else {
          $(".js-image-cropper").removeClass("image-cropper--avatar");
          $(".js-image-cropper").removeClass("image-cropper--image1");
        }

        // initialize the variables
        $(".js-image-cropper-title").text(cropperTitle);
        $(".js-image-cropper-counter").text(imageIndex);
        $(".js-image-cropper-counter-total").text(allImages);

        $(".js-image-cropper").off("shown.bs.modal");
        $(".js-image-cropper").on("shown.bs.modal", function() {
          $("#image-crop-consent").prop("checked", false);
          setupLoader(imageUploader, onCropComplete);
        });

        $(".js-image-cropper").modal({ backdrop: "static" });
      });
    });

    /**
     *
     * The edit of an image field with an existing image.
     *
     */
    $(editButtonWithImage).on("click", function(e) {
      var imageType = $(imageUploader).attr("data-type");
      var imageIndex = $(imageUploader).attr("data-index");
      var allImages = $(".js-image-uploader").length;
      var cropperTitle = $(".js-image-cropper-title").attr("data-other-title");

      // decide what help box to show.
      if (imageType === "avatar") {
        $(".js-image-cropper").addClass("image-cropper--avatar");
        $(".js-image-cropper").removeClass("image-cropper--image1");
        cropperTitle = $(".js-image-cropper-title").attr("data-avatar-title");
      } else if (imageType === "image1") {
        $(".js-image-cropper").removeClass("image-cropper--avatar");
        $(".js-image-cropper").addClass("image-cropper--image1");
        cropperTitle = $(".js-image-cropper-title").attr("data-image1-title");
      } else {
        $(".js-image-cropper").removeClass("image-cropper--avatar");
        $(".js-image-cropper").removeClass("image-cropper--image1");
      }

      // initialize the variables
      $(".js-image-cropper-title").text(cropperTitle);
      $(".js-image-cropper-counter").text(imageIndex);
      $(".js-image-cropper-counter-total").text(allImages);

      $(".js-image-cropper").off("shown.bs.modal");
      $(".js-image-cropper").on("shown.bs.modal", function() {
        // collect data from the existing image to populate the cropper.
        const imageSource = $(
          $(imageUploader)
            .find(".js-image-uploader-target")
            .get(0)
        ).attr("src");

        const description = $(imageUploader)
          .find("input[name=description]")
          .val();

        $(".js-image-cropper-target").attr("src", imageSource);
        $(".js-image-cropper-description").val(description);

        // init the cropper
        initCropper(imageUploader, onCropComplete);
        $(".js-image-cropper").addClass("image-cropper--has-image");
        setupLoader(imageUploader, onCropComplete);
      });

      $(".js-image-cropper").modal({ backdrop: "static" });
    });
  });
}

module.exports = {
  onLoad
};



// WEBPACK FOOTER //
// ./resources/js/libraries/booking-image-cropper/booking-image-cropper.js